/* eslint-disable no-unused-vars */
import React, { memo, useContext } from 'react';
import PropTypes from 'prop-types';
import { StyleSheet, css } from 'aphrodite';
import './css/BannerComponent.css';
import { NavLink } from 'react-router-dom';
import { context } from '../../../../globalState/GlobalState';
import { isValidString } from '../../../../catalog/Validity';
import { checkProductsValidity, checkTicketsValidity } from '../../../../catalog/Store';

const BannerComponent = (props) => {
    const { text, buttonText, navLink, flipped, fullWidth, store, tickets } = props;
    const { globalState } = useContext(context);

    const styles = StyleSheet.create({
        bannerComponentContainer: {
            width: fullWidth ? '100%' : 'auto',
            maxWidth: fullWidth ? '100%' : '550px',
            backgroundColor: globalState.websiteStyles.colors.primaryColor,
            ':before': {
                backgroundColor: 'white',
            },
            ':after': {
                backgroundColor: 'white',
            },
        },
        bannerComponentContainerInside: {
            backgroundColor: 'white',
            ':before': {
                backgroundColor: globalState.websiteStyles.colors.primaryColor,
            },
            ':after': {
                backgroundColor: globalState.websiteStyles.colors.primaryColor,
            },
        },
        bannerComponentContainerLabel: {
            color: globalState.websiteStyles.colors.primaryColor,
        },
        bannerComponentContainerButton: {
            backgroundColor: globalState.websiteStyles.colors.primaryColor,
            color: isValidString(globalState.websiteStyles.colors.fontColor) ? globalState.websiteStyles.colors.fontColor : 'white',
        },
    });

    const flippedStyles = StyleSheet.create({
        bannerComponentContainer: {
            width: fullWidth ? '100%' : 'auto',
            maxWidth: fullWidth ? '100%' : '550px',
            backgroundColor: 'white',
            ':before': {
                backgroundColor: globalState.websiteStyles.colors.primaryColor,
            },
            ':after': {
                backgroundColor: globalState.websiteStyles.colors.primaryColor,
            },
        },
        bannerComponentContainerInside: {
            backgroundColor: globalState.websiteStyles.colors.primaryColor,
            ':before': {
                backgroundColor: 'white',
            },
            ':after': {
                backgroundColor: 'white',
            },
        },
        bannerComponentContainerLabel: {
            color: isValidString(globalState.websiteStyles.colors.fontColor) ? globalState.websiteStyles.colors.fontColor : 'white',
        },
        bannerComponentContainerButton: {
            backgroundColor: isValidString(globalState.websiteStyles.colors.fontColor) ? globalState.websiteStyles.colors.fontColor : 'white',
            color: globalState.websiteStyles.colors.primaryColor,
        },
    });

    const getLogo = () => {
        if (flipped) {
            return globalState.logo.logo2;
        }
        return globalState.silhouetteLogo.logo2;
    };

    const showBanner = () => {
        if (store) {
            if (!checkProductsValidity(globalState)) {
                return false;
            }
        }

        if (tickets) {
            if (!checkTicketsValidity(globalState)) {
                return false;
            }
        }

        return true;
    };

    return (
        <>
            {showBanner() ? (
                <div className="banner-component-container-container">
                    <NavLink to={navLink} className={flipped ? `banner-component-container-flipped ${css(flippedStyles.bannerComponentContainer)}` : `banner-component-container ${css(styles.bannerComponentContainer)}`}>
                        <div className={`banner-component-container-inside ${flipped ? css(flippedStyles.bannerComponentContainerInside) : css(styles.bannerComponentContainerInside)}`}>
                            <p className={`banner-component-label ${flipped ? css(flippedStyles.bannerComponentContainerLabel) : css(styles.bannerComponentContainerLabel)}`}>{text}</p>
                            <button type="button" className={`banner-component-button ${flipped ? css(flippedStyles.bannerComponentContainerButton) : css(styles.bannerComponentContainerButton)}`}>{buttonText}</button>
                        </div>
                        <img src={getLogo()} alt="logo" className="banner-component-logo" />
                    </NavLink>
                </div>
            ) : null}
        </>
    );
};

BannerComponent.propTypes = {
    text: PropTypes.string.isRequired,
    buttonText: PropTypes.string.isRequired,
    navLink: PropTypes.string.isRequired,
    flipped: PropTypes.bool.isRequired,
    fullWidth: PropTypes.bool.isRequired,
    store: PropTypes.bool,
    tickets: PropTypes.bool,
};

BannerComponent.defaultProps = {
    store: false,
    tickets: false,
};

export default memo(BannerComponent);
